"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var FalconDynamicOptimizedMenuList = /** @class */ (function (_super) {
    __extends(FalconDynamicOptimizedMenuList, _super);
    function FalconDynamicOptimizedMenuList(props) {
        var _this = _super.call(this, props) || this;
        _this.baseHeight = 40;
        _this.baseWidth = 263;
        _this.padding = 36;
        _this.getItemSize = function (index) {
            var _a;
            if (!_this.props.children) {
                return _this.baseHeight;
            }
            var childrenArray = React.Children.toArray(_this.props.children);
            var valueAtIndex = childrenArray[index];
            if (React.isValidElement(valueAtIndex) &&
                ((_a = valueAtIndex.props) === null || _a === void 0 ? void 0 : _a.children)) {
                return _this.measureItemHeight(valueAtIndex.props.children);
            }
            return _this.baseHeight;
        };
        _this.containerRef = React.createRef();
        return _this;
    }
    FalconDynamicOptimizedMenuList.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.children === this.props.children) {
            this.calculateScrollOffset();
        }
    };
    FalconDynamicOptimizedMenuList.prototype.render = function () {
        var _a = this.props, children = _a.children, maxHeight = _a.maxHeight;
        var childrenArray = Array.isArray(children) ? children : [children];
        return ((0, jsx_runtime_1.jsx)("div", { ref: this.containerRef, className: "dynamic-menu-list", style: { maxHeight: maxHeight }, children: childrenArray.map(function (child, index) { return ((0, jsx_runtime_1.jsx)("div", { className: "option-wrapper", children: child }, index)); }) }));
    };
    FalconDynamicOptimizedMenuList.prototype.calculateScrollOffset = function () {
        var _a = this.props, options = _a.options, getValue = _a.getValue;
        var selectedValues = getValue();
        var index = selectedValues && selectedValues[0] ? options.indexOf(selectedValues[0]) : 0;
        if (this.containerRef.current) {
            this.containerRef.current.scrollTop = this.getOffset(index);
        }
    };
    FalconDynamicOptimizedMenuList.prototype.getOffset = function (index) {
        if (index < 0) {
            return 0;
        }
        var offset = 0;
        for (var i = 1; i <= index; i++) {
            offset += this.getItemSize(i);
        }
        return offset;
    };
    FalconDynamicOptimizedMenuList.prototype.measureItemHeight = function (content) {
        var tempElement = document.createElement('div');
        tempElement.style.width = this.getWidth() + 'px';
        tempElement.innerHTML = content;
        document.body.appendChild(tempElement);
        var height = tempElement.offsetHeight + 16;
        document.body.removeChild(tempElement);
        return height;
    };
    FalconDynamicOptimizedMenuList.prototype.getWidth = function () {
        var container = document.getElementsByClassName("autocomplete__option").item(0);
        if (container) {
            return container.clientWidth - this.padding;
        }
        var dropdown = document.getElementsByClassName("autocomplete__value-container").item(0);
        return dropdown ? dropdown.clientWidth + 12 : this.baseWidth;
    };
    return FalconDynamicOptimizedMenuList;
}(React.Component));
exports.default = FalconDynamicOptimizedMenuList;
//# sourceMappingURL=FalconDynamicOptimizedMenuList.js.map